import * as React from 'react';
import { createContainer } from '@workday/canvas-kit-react/common';
import { Popup } from '@workday/canvas-kit-react/popup';
import { ModalOverlay } from './ModalOverlay';
import { ModalCard } from './ModalCard';
import { useModalModel } from './hooks';
import { ModalHeading } from './ModalHeading';
import { ModalOverflowOverlay } from './ModalOverflowOverlay';
export var Modal = createContainer()({
    displayName: 'Modal',
    modelHook: useModalModel,
    subComponents: {
        Body: Popup.Body,
        Card: ModalCard,
        CloseIcon: Popup.CloseIcon,
        Target: Popup.Target,
        Heading: ModalHeading,
        Overlay: ModalOverlay,
        OverflowOverlay: ModalOverflowOverlay,
        CloseButton: Popup.CloseButton,
    },
})(function (elemProps) {
    return React.createElement(React.Fragment, null, elemProps.children);
});
